import React, { useState, useEffect, useMemo } from "react";
import { Error } from "../components/Error.component";
import { useGetDevicesQuery } from "../api/api";
import Spinner from "../components/Spinner";
import { Card, Space, Table, Row, Col } from "antd";
import { useParams } from "react-router-dom";
import '../MuseDashboard.css';

export const DevicesDetails = () => {




const { DevicesId } = useParams(); // Use the same parameter name as in the route
const { data, error, isLoading } = useGetDevicesQuery();


  const device = data?.data?.find(item => item.id === DevicesId) || {}; // Find the element matching the DeviceId

  console.log("Fetched data:", data);
  console.log("Device data:", useGetDevicesQuery);
  console.log("Device ID:", DevicesId);

  const columns = [
    { title: "License Name", dataIndex: "licensename_0", key: "licensename_0", className: "table-cell-padding" },
    { title: "Description", dataIndex: "description", key: "description", className: "table-cell-padding" },
    { title: "Unit license Cost (Year)", dataIndex: "costperlicenseperannum_0", key: "costperlicenseperannum_0", render: (value) => `$${Math.round(parseFloat(value))}`, className: "table-cell-padding" },
    { title: "Usage Count", dataIndex: "usageCount", key: "usageCount", className: "table-cell-padding" },
    { title: "Utilization (%)", key: "utilizationPercentage", sorter: (a, b) => {
      const aUtilization = parseFloat(a.usageCount);
      const aPurchased = parseFloat(a.quantitypurchasedlicenses_0);
      const aPercentage = aPurchased ? Math.round((aUtilization / aPurchased) * 100) : 0;
      const bUtilization = parseFloat(b.usageCount);
      const bPurchased = parseFloat(b.quantitypurchasedlicenses_0);
      const bPercentage = bPurchased ? Math.round((bUtilization / bPurchased) * 100) : 0;
      return aPercentage - bPercentage;
    }, render: (text, record) => {
      const utilization = parseFloat(record.usageCount);
      const purchased = parseFloat(record.quantitypurchasedlicenses_0);
      const percentage = purchased ? Math.round((utilization / purchased) * 100) : 0;
      let color = "green";
      let fontWeight = "normal";
      if (percentage >= 90) {
        color = "red";
        fontWeight = "bold";
      } else if (percentage >= 80) {
        color = "orange";
      }
      return <span style={{ color, fontWeight }}>{`${percentage}%`}</span>;
    }, className: "table-cell-padding" },
  ];

  const enrolleddatetime = new Date(device.enrolleddatetime).toLocaleDateString();
  const lastSyncDate = new Date(device.lastsyncdatetime).toLocaleDateString();
  
  return (
    <div className="montserrat-font">
      {isLoading && <Spinner />}
      {error && <Error error={"Oops"} />}
      {data && !error && (
        <div>
          <Row gutter={32}>
      
            <Col xs={24} sm={12}>
              <Card title="Device Overview" className="muse-card qual-height-card" style={{ width: "100%" }}>
              <h3>Device Name: <strong>{device.devicename}</strong></h3>
              <h3>Used By: <strong>{device.userdisplayname}</strong></h3>
                <h3>Managed: <strong>{device.compliancestate}</strong></h3>
                <h3>User: <strong>{device.manageddeviceownertype}</strong></h3>
                <h3>Phonenumber: <strong>{device.phonenumber}</strong></h3>
                <h3>Last Synced Date: <strong>{lastSyncDate}</strong></h3>
              </Card>
            </Col>
            <Col xs={24} sm={12}>
              <Card title="Hardware Overview" className="muse-card qual-height-card" style={{ width: "100%" }}>
                <h3>Model: <strong>{device.model}</strong></h3>
                <h3>Manufacturer: <strong>{device.manufacturer}</strong></h3>
                <h3>Serial number: <strong>{device.serialnumber}</strong></h3>
                <h3>Operating System: <strong>{device.operatingsystem}</strong></h3>
                <h3>OS Version: <strong>{device.osversion}</strong></h3>
                <h3>imei: <strong>{device.imei}</strong></h3>
              </Card>
            </Col>
          </Row>
          <Row>
            <Card className="muse-card" style={{ width: "100%" }}>
              <Table
                columns={columns}
                dataSource={[{ ...device, key: DevicesId }]} // Add a unique key to each item
                className="montserrat-font"
                rowClassName={() => "table-row-spacing"}
              />
            </Card>
          </Row>
        </div>
      )}
    </div>
  );
};
